import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";
import {useAppContext} from "../../../contexts/AppContext";
import {ACTION_LABELS} from "../Activity/AdminActivity";
import {useQuestions} from "../../../contexts/QuestionsContext";

// Д1 — Табло: обобщени числа за избраната стопанска година + сигнали.
export const AdminDashboard = () => {
    const {years} = useAppContext();
    const request = requester();
    const {unanswered} = useQuestions();

    const sortedYears = [...years].sort((a, b) => a.year - b.year);
    const lastYear = sortedYears.length ? sortedYears[sortedYears.length - 1].year : '';
    const [year, setYear] = useState('');
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!year && lastYear) setYear(String(lastYear));
    }, [lastYear, year]);

    useEffect(() => {
        if (!year) return;
        setError('');
        request.get(`${baseUrl()}/admin/dashboard/${year}`)
            .then(setData)
            .catch(err => setError(err.message || 'Грешка при зареждане на таблото.'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year]);

    const num = (n) => (n ?? 0).toLocaleString('bg-BG');
    const area = (n) => `${(n ?? 0).toLocaleString('bg-BG', {maximumFractionDigits: 1})}`;

    const tiles = data ? [
        {label: 'землища с данни', value: num(data.settlements_with_data)},
        {label: 'ползватели', value: num(data.companies_count)},
        {label: 'замени (ДЗ)', value: num(data.deals_count)},
        {label: 'площ на замените', value: area(data.deals_area_sum)},
        {label: 'изчертана площ', value: area(data.drawings_area_sum)},
    ] : [];

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <h3 className="me-auto mb-0">Табло</h3>
                <label className="me-2">Стопанска година:</label>
                <select className="form-select w-auto" value={year}
                        onChange={e => setYear(e.target.value)}>
                    {sortedYears.map(y => (
                        <option key={y.year} value={y.year}>{y.year}</option>
                    ))}
                </select>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            {/* И2: сигнал за чакащи въпроси. Показва се само когато има какво да
                се направи — иначе таблото се пълни с празни редове. Числото НЕ е
                по година (въпросите не са вързани за стопанска година). */}
            {unanswered > 0 && (
                <div className="alert alert-warning d-flex align-items-center gap-2">
                    <span>
                        Има <strong>{unanswered}</strong>{' '}
                        {unanswered === 1 ? 'въпрос' : 'въпроса'} от потребители без отговор.
                    </span>
                    <Link to="/admin/questions" className="ms-auto">Към въпросите</Link>
                </div>
            )}

            <div className="row g-3 mb-4">
                {tiles.map(t => (
                    <div className="col-6 col-md-4 col-lg" key={t.label}>
                        <div className="card h-100">
                            <div className="card-body">
                                <div className="fs-4 fw-bold">{t.value}</div>
                                <div className="text-muted small">{t.label}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row g-3">
                <div className="col-md-6">
                    <div className="card h-100">
                        <div className="card-header">Внимание</div>
                        <div className="card-body">
                            {!data || data.alerts.length === 0
                                ? <p className="text-muted mb-0">Няма землища с данни, но без изчертаване.</p>
                                : (
                                    <>
                                        <p className="mb-2">Землища с изходни данни, но без нито едно изчертаване:</p>
                                        <ul className="mb-0">
                                            {data.alerts.map(a => (
                                                <li key={a.ekatte}>
                                                    <Link to={`/${year}/settlements/${a.ekatte}/companies`}>
                                                        {a.name} ({a.ekatte})
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center">
                            <span className="me-auto">Последни действия</span>
                            <Link to="/admin/activity" className="small">Целият журнал →</Link>
                        </div>
                        <div className="card-body">
                            {!data || data.last_actions.length === 0
                                ? <p className="text-muted mb-0">Все още няма записани действия.</p>
                                : (
                                    <ul className="list-unstyled mb-0 small">
                                        {data.last_actions.map((a, i) => (
                                            <li key={i} className="border-bottom py-1">
                                                <span className="text-muted">{a.create_on}</span>
                                                {' — '}
                                                <strong>{a.username}</strong>
                                                {' · '}
                                                {ACTION_LABELS[a.action] || a.action}
                                                {a.details ? ` (${a.details})` : ''}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
